import { s, Shape } from "@kosmod/pancake";

export type TheatreVector = { x: number, y: number, z: number };
export type TheatreVector4 = { x: number, y: number, z: number, w: number };

export const theatreVectorDef = s.ref<TheatreVector>()(s.o({
  x: s.num,
  y: s.num,
  z: s.num,
}));

export const TheatreVector3 = s.ref<TheatreVector>()(s.o({
  x: s.num,
  y: s.num,
  z: s.num,
  w: s.num,
}));
export const TheatreVector4 = s.ref<TheatreVector4>()(s.o({
  x: s.num,
  y: s.num,
  z: s.num,
  w: s.num,
}));
